export enum FactionWorkType {
  HACKING = "HACKING",
  FIELD = "FIELD",
  SECURITY = "SECURITY",
}
